import React from "react";
import Carousel from 'react-multi-carousel';
import * as debounce from "lodash.debounce";
import MultiCarouselScrollbar from "./../MultiCarouselElements/MultiCarouselScrollbar";

class MultiCarousel extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isMounted: false,
            setInitialCarouselState: true,
            scrollBarLeftPosition: 0,
            scrollBarWidth: 0,
            carouselState: {},
        };
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        this.Carousel.containerRef.current.addEventListener('touchstart', this.touchStart);
        this.Carousel.containerRef.current.addEventListener('touchmove', this.preventTouch, { passive: false });

        if (this.props.items) {
            this.setState({
                isMounted: true,
                carouselState: this.Carousel.state,
                screenWidth: window.screen.width,
            });
        }
        window.addEventListener("resize", this.handleResize);
    }

    componentDidUpdate() {

        if (this.Carousel.state != this.state.carouselState)
            this.setState({
                carouselState: this.Carousel.state,
            });
    }

    componentWillUnmount() {
        this.Carousel.containerRef.current.removeEventListener('touchstart', this.touchStart);
        this.Carousel.containerRef.current.removeEventListener('touchmove', this.preventTouch, { passive: false });
    }

    touchStart(e) {
        this.firstClientX = e.touches[0].clientX;
        this.firstClientY = e.touches[0].clientY;
    }

    preventTouch(e) {
        const minValue = 5; // threshold

        this.clientX = e.touches[0].clientX - this.firstClientX;
        this.clientY = e.touches[0].clientY - this.firstClientY;

        // Vertical scrolling does not work when you start swiping horizontally.
        if (Math.abs(this.clientX) > minValue) {
            e.preventDefault();
            e.returnValue = false;
            return false;
        }
    }

    handleResize = debounce(
        () => {
            if (this.state.screenWidth != window.screen.width && this.Carousel) { //To solve issue with iOS triggering resize event when scrolling
                this.Carousel.goToSlide(0, false);
                this.setState({
                    screenWidth: window.screen.width
                });
            }
        },
        500
    );

    render() {
        const { cssBlock, settings, children, color } = this.props;
        return (
            <>
                <Carousel
                    {...settings}
                    ref={(el) => (this.Carousel = el)}
                    afterChange={(previousSlide, { currentSlide, onMove }) => {
                        this.setState({
                            carouselState: this.Carousel.state,
                        });
                    }}
                >
                    {children}
                </Carousel >
                {this.state.isMounted &&
                    <MultiCarouselScrollbar carouselState={this.state.carouselState} cssBlock={cssBlock} color={color}/>
                }
            </>
        );
    }
};
export default MultiCarousel;